import Vue from 'vue';
import { email, required } from 'vuelidate/lib/validators';
import FormFieldWrapper from '@/forms/FormFieldWrapper.vue';
export default Vue.extend({
    components: { FormFieldWrapper },
    props: {
        title: {
            type: String,
            default: 'Create new password',
        },
        apiErrors: {
            type: Object,
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            form: {
                email: '',
            },
        };
    },
    validations: {
        form: {
            email: {
                email,
                required,
            },
        },
    },
    methods: {
        onSubmit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                this.$emit('formSubmitted', this.form);
            }
        },
        clearApiErrors(fieldName) {
            this.$emit('clearApiErrors', fieldName);
        },
    },
});
